class Translations {
  DICTIONARY = {
    "pt": {
      "login_button_content": "Acessar com a conta PRÓ-VIDA",
      "login_switch_wordpress": "Mostra Login Wordpress",
    },
    "en": {
      "login_button_content": "Login using PRÓ-VIDA account",
      "login_switch_wordpress": "Mostra Login Wordpress",
    },
    "es": {
      "login_button_content": "Login using PRÓ-VIDA account",
      "login_switch_wordpress": "Mostra Login Wordpress",
    },
    "it": {
      "login_button_content": "Login using PRÓ-VIDA account",
      "login_switch_wordpress": "Mostra Login Wordpress",
    }
  };

  DEFAULT_LANGUAGE = "en";

  constructor(language){
    this.language = language;
  }

  get_translation = (key) => {
    let content = "";
    let dict = this.DICTIONARY[this.language];
    content = (dict ? dict[key] : null);
    if(!content){
      let subLang = this.language.split("_");
      dict = this.DICTIONARY[subLang[0]];
      content = (dict ? dict[key] : null);
      if(!content){
        content = this.DICTIONARY[this.DEFAULT_LANGUAGE][key];
      }
    }
    return content;
  }
}

export default Translations;
